export const tableHeaders = [
  {
    id: 1,
    label: 'Key',
    intlKey: 'table.key'
  },
  {
    id: 2,
    label: 'Last used',
    intlKey: 'table.lastUsed'
  },
  {
    id: 3,
    label: 'Action',
    intlKey: 'table.action'
  }
]
